export default __webpack_public_path__ + "static/media/chicken-and-waffles.446e1eb8.jpg";